module.exports = __webpack_public_path__ + "assets/images/leaderboardFiltering-295abaace418931730fbb8ba48ba1312.png";